<template>
  <div>
    <v-list-group
      v-for="item in myItems"
      :key="item.id"
      :value="item.open"
      no-action
      sub-group
      class="child-pl-neg"
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t(item.subGroupNameI18nCode) }}
            <span
              class="ml-3"
              :class="subItemJobNums[item.id] > 0 ? 'pink--text': 'grey--text'"
            >{{ subItemJobNums[item.id] }}</span>
          </v-list-item-title>
        </v-list-item-content>
      </template>

      <v-list-item
        v-for="subItem in item.subItems"
        :key="subItem.title"
        active-class="primary--text"
        :input-value="isActiveItem(subItem)"
        @click="toPage(subItem)"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ $t(subItem.nameI18nCode) }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-list-item-action-text
            :class="subItem.finalJobNum > 0 ? 'pink--text': 'grey--text'"
          >
            {{ subItem.finalJobNum }}
          </v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
    </v-list-group>
  </div>
</template>

<script>
import _ from 'lodash'
import { workflowModule } from '@/store/moduleName'
import { TASK_LIST_JOB_TYPE } from '@/constant/constant'

export default {
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    subItemJobNums: {
      type: Array,
      default: function () {
        return []
      }
    },
    jobType: {
      type: Number,
      required: true
    },
    currentJobType: {
      type: Number,
      required: true
    },
    currentPath: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      open: false,
      isNotDirty: true,
      myItems: []
    }
  },
  watch: {
    items: {
      handler: function () {
        let tItems = _.cloneDeep(this.items)
        tItems.forEach(item => {
          item.open = false

          // add finalUrl and finalHistoryUrl to list base on jobType
          item.subItems.forEach(subItem => {
            if (this.jobType === TASK_LIST_JOB_TYPE.MY_JOB) {
              subItem.finalUrl = subItem.url
              subItem.finalHistoryUrl = subItem.historyUrl
              subItem.finalJobNum = subItem.jobNum
            } else if (this.jobType === TASK_LIST_JOB_TYPE.GROUP_JOB) {
              subItem.finalUrl = subItem.groupUrl
              subItem.finalHistoryUrl = subItem.groupHistoryUrl
              subItem.finalJobNum = subItem.groupJobNum
            } else if (this.jobType === TASK_LIST_JOB_TYPE.ATTENTION_JOB) {
              subItem.finalUrl = subItem.attentionUrl
              subItem.finalHistoryUrl = subItem.attentionHistoryUrl
              subItem.finalJobNum = subItem.attentionJobNum
            }
          })
        })
        this.myItems = tItems
        this.openActiveGroup()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    isActiveItem (subItem) {
      return (this.currentPath.includes(subItem.finalUrl)) || (this.currentPath.includes(subItem.finalHistoryUrl))
    },
    isActiveSubGroup (item) {
      // Check if the gruop active
      let temp = item.subItems.some(subItem => {
        return this.isActiveItem(subItem)
      })
      return temp
    },
    openActiveGroup () {
      let temp = false
      for (const index in this.myItems) {
        const item = this.myItems[index]
        if (this.isActiveSubGroup(item)) {
          item.open = true
          temp = true
        }
      }
      return temp
    },
    async toPage (subItem) {
      if (this.jobType === TASK_LIST_JOB_TYPE.ATTENTION_JOB) {
        // If don't call below functions, the content in target page will not updated.
        await this.$store.dispatch(workflowModule + '/getMyAttentionStaffs', subItem.businessCode)
        // this.$store.dispatch(workflowModule + '/getAttentionActiveItems', { 'businessCode': item.businessCode, 'euid': this.myAttentionStaffs[0].euid })
      }
      if (subItem.businessCode !== 'training') {
        this.$store.dispatch(workflowModule + '/getItemByBusinessCode', subItem.businessCode)
        // this.$store.dispatch(workflowModule + '/getActiveItems', item.businessCode)
      }
      // Bug fix for Throw Error "NavigationDuplicated" on clicking same url
      // https://github.com/vuejs/vue-router/issues/2872
      // https://stackoverflow.com/questions/57837758/navigationduplicated-navigating-to-current-location-search-is-not-allowed
      if (this.$route.path !== subItem.finalUrl) {
        this.$router.push(subItem.finalUrl)
      }
      this.$emit('item-click')
    },
    expendTheBest () {
      for (const index in this.myItems) {
        this.myItems[index].open = false
      }

      this.$nextTick(() => {
        let isAlreadyOpen = this.openActiveGroup()
        if (!isAlreadyOpen) {
          for (const index in this.myItems) {
            const item = this.myItems[index]
            if (this.subItemJobNums[item.id]) {
              item.open = true
              break
            }
          }
        }
      })

      // this.open = true
      // this.isNotDirty = false
      // this.$nextTick(() => {
      //   this.isNotDirty = true
      // })
    }
    // collapse () {
    //   this.open = false
    // }
  }
}
</script>
